import * as Usuario from './usuario';

export const Initialize = () => {
    $('.salir').click(function(){
        return Logout();
    });
};

export const Logout = () => {
    return Usuario.Salir();
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/logout.js